// extracted by mini-css-extract-plugin
module.exports = {"filesContainer":"PosDisputesFiles_filesContainer__1YqAM","filesListContainer":"PosDisputesFiles_filesListContainer__fhrVn","filesButton":"PosDisputesFiles_filesButton__3g_ir"};